import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 1 }

import { inject, type Ref } from "vue";
import StudioIcon from "./StudioIcon.vue";
import { studioSessionHistoryKey } from "./studioSessionHistory";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudioHistoryToolbar',
  props: {
    history: {},
    disabled: { type: Boolean },
    sessionToolbar: { type: Boolean },
    compact: { type: Boolean },
    local: { type: Boolean }
  },
  setup(__props: any) {


const session = inject(studioSessionHistoryKey, undefined);

return (_ctx: any,_cache: any) => {
  return (__props.sessionToolbar || __props.local || !_unref(session))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["studio-history-tools", { compact: __props.compact }]),
        "data-studio-history-tools": "",
        role: "group",
        "aria-label": "编辑历史"
      }, [
        _createElementVNode("button", {
          type: "button",
          "aria-label": "撤销",
          title: "撤销 · Ctrl+Z",
          disabled: __props.disabled || !__props.history?.canUndo.value,
          onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.history?.undo()))
        }, [
          (__props.compact)
            ? (_openBlock(), _createBlock(StudioIcon, {
                key: 0,
                name: "undo",
                size: 17
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, "撤销"))
        ], 40, _hoisted_1),
        _createElementVNode("button", {
          type: "button",
          "aria-label": "重做",
          title: "重做 · Ctrl+Shift+Z / Ctrl+Y",
          disabled: __props.disabled || !__props.history?.canRedo.value,
          onPointerdown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.history?.redo()))
        }, [
          (__props.compact)
            ? (_openBlock(), _createBlock(StudioIcon, {
                key: 0,
                name: "redo",
                size: 17
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "重做"))
        ], 40, _hoisted_3)
      ], 2))
    : _createCommentVNode("", true)
}
}

})